
import { useQuery } from '@tanstack/react-query';
import { INFLUENCE_FILTERS, InfluenceFilterData } from '../data/influence-filters';

/**
 * Hook to fetch influence prompts from static data with category filtering
 */
export const useStaticInfluencePrompts = (imageType: string | null) => {
  return useQuery({
    queryKey: ['static-influence-prompts', imageType],
    enabled: !!imageType,
    queryFn: async (): Promise<InfluenceFilterData[]> => {
      if (!imageType) return [];
      
      // Simulate async behavior to maintain interface compatibility
      await new Promise(resolve => setTimeout(resolve, 1));
      
      return INFLUENCE_FILTERS
        .filter(influence => influence.category.toLowerCase() === imageType.toLowerCase())
        .sort((a, b) => b.priority - a.priority);
    },
    staleTime: Infinity, // Static data never goes stale
    gcTime: Infinity, // Keep in cache forever
  });
};
